import { useCallback } from 'react';

const useSortChange = (setState, sortColumn, sortType) => {
  return useCallback(
    (columnName) => {
      let type = null;
      if (columnName === sortColumn) {
        type = sortType === 'asc' ? 'desc' : 'asc';
      }

      setState((previous) => {
        return {
          ...previous,
          page: 1,
          sortColumn: columnName,
          sortType: type ? type : previous.sortType,
        };
      });
    },
    [setState, sortColumn, sortType],
  );
};

export default useSortChange;
